import { useAmplitudeContext } from '@/analytics/amplitudeProvider';
import { type FragmentType, useFragment } from '@/gql/codegen';
import { graphql } from '@/gql/codegen/gql';
import { useCallback } from 'react';

export const EMBA_USER_IDENTIFIER_FRAGMENT = graphql(/* GraphQL */ `
  fragment embaUserIdentifier on User {
    id
    organizationId
    isGlobis
  }
`);

export const useInitEmbaUserIdentifier = (
  embaUser: FragmentType<typeof EMBA_USER_IDENTIFIER_FRAGMENT>,
) => {
  const { amplitude } = useAmplitudeContext();
  const embaUserData = useFragment(EMBA_USER_IDENTIFIER_FRAGMENT, embaUser);

  const initEmbaUserIdentifier = useCallback(() => {
    amplitude.setUserId(embaUserData.id);

    const identifyEvent = new amplitude.Identify();
    identifyEvent.set('organization_id', embaUserData.organizationId);
    identifyEvent.set('is_globis', embaUserData.isGlobis);
    amplitude.identify(identifyEvent);
  }, [
    amplitude,
    embaUserData.id,
    embaUserData.organizationId,
    embaUserData.isGlobis,
  ]);

  return initEmbaUserIdentifier;
};
